import { FC, useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

import ProjectCardIcon from 'components/parts/project-card-icon/project-card-icon'
import usePCWindow from 'hooks/usePCWindow'

import { getAxiosSingle } from 'pages/api/axios'
import { ScreenSize } from 'constants/media-constanst'
import { STATISTIC_SERVICE_URL, currImageDomain } from 'constants/data'
import { iconsData } from './data'
import { IProjectCard } from 'constants/types/card.types'

import styles from './project-card.module.scss'

const ProjectCard: FC<IProjectCard> = ({
  id,
  title,
  description,
  preview,
  list,
  isInteractive,
}) => {
  const [dopInfo, setDopInfo] = useState({ likes: 0, views: 0 })
  const [isLoading, setIsLoading] = useState(false)
  const isBigScreen = usePCWindow(ScreenSize.big)

  useEffect(() => {
    setIsLoading(true)
    const getLikesAndView = async () => {
      const { likeCount } = await getAxiosSingle(`${STATISTIC_SERVICE_URL}/likePlaylist/${id}`)
      const { views } = await getAxiosSingle(`${STATISTIC_SERVICE_URL}/uniqueViewsPlaylist/${id}`)
      setDopInfo({ likes: likeCount, views })
      setIsLoading(false)
    }
    !isInteractive && getLikesAndView()
  }, [])

  const bottomCard = !isLoading ? (
    <div className={styles.cardBottom}>
      <ProjectCardIcon
        count={dopInfo.views}
        iconUrl={iconsData.views.path}
        altDesc={iconsData.views.alt}
      />
      <ProjectCardIcon
        count={dopInfo.likes}
        iconUrl={iconsData.likes.path}
        altDesc={iconsData.likes.alt}
      />
    </div>
  ) : (
    <Skeleton width={100} height={19} />
  )

  return (
    <div className={styles.cardWrap}>
      {!isBigScreen && !isInteractive && bottomCard}
      {/* TODO: Использовать getPreview */}
      <img
        className={clsx(styles.image, {
          [styles.imgInteractive]: isInteractive,
        })}
        src={`${currImageDomain}/imgproxy/insecure/width:700/plain/local:${preview}`}
        alt={title}
      />
      <div className={styles.wrapRight}>
        {isInteractive ? (
          <div className={styles.cardTop}>
            <span className={styles.type}>ИНТЕРАКТИВ</span>
          </div>
        ) : (
          <div className={styles.cardTop}>
            <span className={styles.type}>ВИДЕОПРОЕКТ</span>
            <span className={styles.videoCount}>{`${list.length} видео`}</span>
          </div>
        )}
        <div className={styles.cardText}>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
        {isBigScreen && !isInteractive && bottomCard}
      </div>
    </div>
  )
}

export default ProjectCard
